/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSinkComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'sink', true).withAlias('LynxSink').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'SINK_LYNX_LSK',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'sink', true).withAlias('LynxSink').attach(memoEval((self)=>[
            self.$applianceOffsetX,
            self.$applianceOffsetY,
            self.$width
        ], ($applianceOffsetX, $applianceOffsetY, $width)=>({
            offsetX: $applianceOffsetX,
            offsetY: $applianceOffsetY,
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 18 * 25.4,
                    scaleOne: 30 * 25.4
                }
            }
        })))
];

//# sourceMappingURL=lynx-sink.js.map